// CORE-1735 slice 17 (D-120, QA V06) — Live icon «play» from the published set v4.2
// (Confluence 110461314, archive reference-icons-v4.2): geometry as shipped, strokes 1.8,
// paint from the caller (`color` — solid or an ink gradient reference), the inner
// highlight through `filter` (the toolbar's «live-polish»), the slash cut by `cut`.
import React from 'react';
import Svg, { G, Path } from 'react-native-svg';
import type { LiveGlyphProps } from '../types';

export const Play: React.FC<LiveGlyphProps> = ({ size, color, filter }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <G filter={filter} fill={color} fillRule="evenodd">
    <Path d="M6 3l16 9L6 21Z" fill={color} />
    </G>
  </Svg>
);
